import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import FTSiderBox from './ftSiderBox';
import IpadAd from '../../../components/ipadAd';

class FTNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ftNewsSiderContent, ftNewsSiderAd, ipadAd4 },
        } = this.props;

        return (
            <div id="fashionSiderList" className={styles.sider_box}>
                <div className={styles.sider}>
                    <Chip
                        id="50095"
                        type="struct"
                        title="时尚要闻区左侧栏标题"
                        groupName="时尚旅游要闻区左侧栏"
                        content={ftNewsSiderContent}>
                        <FTSiderBox />
                    </Chip>
                </div>
                <NoSSR>
                    {ftNewsSiderAd ? (
                        <Ad content={ftNewsSiderAd} />
                    ) : (
                        <Chip id="40106" type="static" title="广告5" groupName="时尚旅游要闻区左侧栏" content={ipadAd4}>
                            <IpadAd />
                        </Chip>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(FTNewsSider);
